const state = {
  isEnabled: false,
  enabledAt: null,
};

const mutations = {
  SET_ENABLED(currentState, enabled) {
    currentState.isEnabled = enabled;
    currentState.enabledAt = enabled ? new Date().toISOString() : null;
  },
};

const actions = {
  enable({ commit }) {
    commit('SET_ENABLED', true);
  },
  disable({ commit }) {
    commit('SET_ENABLED', false);
  },
};

const getters = {
  isEnabled(currentState) {
    return currentState.isEnabled;
  },
  enabledAt(currentState) {
    return currentState.enabledAt;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
